"use client";

import { cx } from "@/lib/tailwind-utils";

export function ProgressLine({
  done,
  total,
  className,
  label,
}: {
  done: number;
  total: number;
  className?: string;
  /** Accessible description, e.g. "14 of 26 setup items done". */
  label: string;
}) {
  const safeTotal = Math.max(total, 1);
  const donePct = Math.min(100, (done / safeTotal) * 100);

  return (
    <div
      role="progressbar"
      aria-valuenow={done}
      aria-valuemin={0}
      aria-valuemax={total}
      aria-label={label}
      className={cx(
        "flex h-1.5 w-full overflow-hidden rounded-full bg-border",
        className,
      )}
    >
      <span
        className="h-full bg-primary transition-[width] duration-300 ease-out motion-reduce:transition-none"
        style={{ width: `${donePct}%` }}
      />
    </div>
  );
}
